export default __webpack_public_path__ + "static/spedycja-8a5f9e91662c5d51f5b7dc09e9857288.jpg";